import React, { useEffect, useState } from 'react';
import {
  Box,
  Text,
  Grid,
  Checkbox,
  Badge,
  HStack,
  Flex
} from '@chakra-ui/react';

import { fetchWrapper } from '../../../../helpers';
import { FaMessage } from 'react-icons/fa6';
import { CHANNEL_IDS, withChannelMeta } from '../../../../utils/channels';

export const CommunicationChannels = ({ formData, setFormData }) => {
  const [selectedChannels, setSelectedChannels] = useState(
    (formData.selectedChannels || []).map(String)
  );
  const [channelOptions, setChannelOptions] = useState([]);

  const loadChannels = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/channel/list`;
      const res = await fetchWrapper.get(url);

      const allowedChannelIds = formData?.selectedTemplate?.channel_id
        ? JSON.parse(formData?.selectedTemplate?.channel_id || "[]")
        : (formData?.selectedChannels || []);
      const visibleChannelIds =
        formData?.audienceType === 'all_subscribers'
          ? [CHANNEL_IDS.PUSH]   // 👈 force only these two
          : allowedChannelIds;


      const visibleChannelIdStrings = visibleChannelIds.map(String);

      const formatted = withChannelMeta(res?.data)
        .map((channel) => ({
          description: 'No description',
          color: 'blue',
          features: ['Basic Messaging'],
          limitations: '',
          ...channel,
          id: String(channel.id),
        }))
        .filter((channel) => visibleChannelIdStrings.includes(channel.id));

      setChannelOptions(formatted);
    } catch (err) {
      console.error('Failed to load channels', err);
    }
  };


  useEffect(() => {
    loadChannels();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleChannel = (channelId) => {
    const id = String(channelId);
    setSelectedChannels(prev => {
      const updatedChannels = prev.includes(id)
        ? prev.filter(c => c !== id)
        : [...prev, id];
      setFormData(fd => ({ ...fd, selectedChannels: updatedChannels }));
      return updatedChannels;
    });
  };


  const removeChannel = (channelId) => {
    const updatedChannels = selectedChannels.filter(id => id !== channelId);
    setSelectedChannels(updatedChannels);
    setFormData(prev => ({
      ...prev,
      selectedChannels: updatedChannels
    }));
  };

  useEffect(() => {
    // Normalize selectedChannels in formData to strings on mount
    const normalized = (formData.selectedChannels || []).map(String);
    setFormData(prev => ({ ...prev, selectedChannels: normalized }));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box >
      <Box p={2}>
        <Box mb={4}>
          <Text fontSize="xl" fontWeight="semibold" color="gray.800">
            Select Communication Channels
          </Text>
          <Text fontSize="sm" color="gray.600" mt={1}>
            Choose one or more channels to deliver your campaign. You can select multiple channels for better reach.
          </Text>
        </Box>
        <Grid templateColumns="repeat(2, 1fr)" gap={4} mb={6}>
          {channelOptions.map((channel) => {
            const isSelected = selectedChannels.includes(String(channel.id));
            const isDisabled = false

            return (
              <Box
                key={channel.id}
                border={isSelected ? '1px solid var(--brand-primary)' : '1px solid #e2e8f0'}
                bg={isSelected ? 'blue.50' : 'white'}
                cursor={isDisabled ? 'not-allowed' : 'pointer'}
                onClick={() => !isDisabled && toggleChannel(channel.id)}
                opacity={isDisabled ? 0.6 : 1}
                _hover={!isDisabled ? { borderColor: 'var(--brand-primary)', shadow: 'sm' } : {}}
                transition="all 0.2s"
                borderRadius={"8.25px"}
              >
                <Box p={4}>
                  <HStack justify="space-between" mb={3}>
                    <Box>
                      <HStack spacing={2}>
                        <Text fontWeight="semibold" color="gray.800">
                          {channel.label}
                        </Text>
                        {channel.popular && (
                          <Badge colorScheme="orange" size="sm">Popular</Badge>
                        )}
                      </HStack>
                    </Box>
                    <Checkbox
                      isChecked={isSelected}
                      isDisabled={isDisabled}
                      colorScheme="blue"
                      onChange={() => {}}
                      pointerEvents="none"
                    />
                  </HStack>
                </Box>
              </Box>
            );
          })}

        </Grid>
        {formData.selectedChannels?.length <= 0 && (<Box border={"3px"} borderStyle={"dashed"} borderColor={"#ebe6e7"} p="16">
          <Flex justifyContent={"center"} alignItems={"center"} direction={"column"}>
            <FaMessage color='#d1d5dc' fontSize={"24px"} />
            <Text color='black' fontSize={"sm"} fontWeight={"semibold"}>No channel selected</Text>
            <Text fontSize={"xs"} color={"#6a7282"} fontWeight={"hairline"}>Please select at least once compatible channel to launch your campaign</Text>
          </Flex>
        </Box>)}


        {/* {selectedChannels.length > 0 && (
          <Box>
            <Text fontSize="sm" fontWeight="semibold" mb={3} color="gray.800">
              Selected Channels Summary
            </Text>
            <HStack spacing={2} flexWrap="wrap">
              {selectedChannels.map((channelId) => {
                const channel = channelOptions.find(c => c.id === channelId);
                return (
                  <Tag
                    key={channelId}
                    size="md"
                    borderRadius="full"
                    variant="solid"
                    bg="var(--brand-primary)"
                    color="white"
                  >
                    <TagLabel>{channel?.name}</TagLabel>
                    <TagCloseButton onClick={() => removeChannel(channelId)} />
                  </Tag>
                );
              })}
            </HStack>
          </Box>
        )} */}
      </Box>
    </Box>
  );
};
